import { ArrowRight } from "lucide-react";
import { Button, Highlight, Section } from "@/components/ui";
import { FINAL_CTA } from "@/data/home";

/** Full literals so Tailwind sees them. */
const STEP_BADGES = ["bg-brand-500 text-white", "bg-brand-500 text-white", "bg-brand-500 text-white"];

export function FinalCta() {
  return (
    <Section tone="sunTint" labelledBy="final-cta-title" testId="home-final-cta" spacing="roomy">
      <div className="relative z-10 grid items-center gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <h2
            id="final-cta-title"
            className="max-w-[14ch] font-heading text-5xl font-bold leading-[1.02] sm:text-6xl lg:text-7xl"
          >
            {FINAL_CTA.title}{" "}
            <Highlight>{FINAL_CTA.accent}</Highlight>
          </h2>
          <p className="mt-5 max-w-[40ch] text-lg text-ink/70 sm:text-xl">{FINAL_CTA.sub}</p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Button to={FINAL_CTA.cta.to} size="lg" data-testid="home-final-cta-button">
              {FINAL_CTA.cta.label}
              <ArrowRight className="h-5 w-5" aria-hidden="true" />
            </Button>
            <Button to={FINAL_CTA.secondary.to} variant="outline" size="lg" data-testid="home-final-cta-contact">
              {FINAL_CTA.secondary.label}
            </Button>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-5xl bg-white p-6 text-ink shadow-soft sm:p-8">
            <h3 className="font-heading text-2xl font-bold sm:text-3xl">{FINAL_CTA.stepsTitle}</h3>
            <ol className="relative mt-6 space-y-6">
              <span aria-hidden="true" className="absolute bottom-6 left-[1.4rem] top-6 border-l-2 border-dashed border-brand-200" />
              {FINAL_CTA.steps.map((step, i) => (
                <li key={step.id} className="relative flex gap-4">
                  <span
                    className={`relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-heading text-xl font-bold ${STEP_BADGES[i % STEP_BADGES.length]}`}
                    aria-hidden="true"
                  >
                    {i + 1}
                  </span>
                  <div>
                    <h4 className="font-heading text-lg font-bold leading-tight sm:text-xl">{step.title}</h4>
                    <p className="mt-1 text-sm text-ink/70 sm:text-base">{step.text}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </Section>
  );
}
